import { AxiosError } from 'axios'

import { AppDispatch } from '../../store'
import { fetchPreferences, setPreferenceCall } from '../apiCalls'
import {
  GET_PREFERENCES_LOADING,
  GET_PREFERENCES_FAILURE,
  GET_PREFERENCES_SUCCESS,
  SET_PREFERENCE_FAILURE,
  SET_PREFERENCE_SUCCESS,
  SET_PREFERENCE_LOADING,
} from '../interface/actionTypes'
import { IPreference } from '../interface/IPreference'

import { preferenceResponseTransformer } from './preferenceResponseTransformer'

const getPreferencesSuccess = (list: IPreference) => {
  return {
    type: GET_PREFERENCES_SUCCESS,
    payload: {
      preferences: list,
    },
  }
}

const getPreferencesFailure = (error: string) => ({
  type: GET_PREFERENCES_FAILURE,
  payload: {
    error,
  },
})

export const getPreferences = (establishmentUuid: string | undefined) => {
  return (dispatch: AppDispatch) => {
    dispatch({ type: GET_PREFERENCES_LOADING })
    return fetchPreferences(establishmentUuid)
      .then(response =>
        dispatch(
          getPreferencesSuccess(preferenceResponseTransformer(response.data)),
        ),
      )
      .catch((error: AxiosError) =>
        dispatch(getPreferencesFailure(error.message)),
      )
  }
}

const setPreferenceSuccess = (name: string, value: any) => ({
  type: SET_PREFERENCE_SUCCESS,
  payload: {
    name,
    newValue: value,
  },
})

const setPreferenceFailure = (error: string) => ({
  type: SET_PREFERENCE_FAILURE,
  payload: { error },
})

export const setPreference = (
  establishmentUuid: string | undefined,
  name: string,
  value: any,
) => {
  return (dispatch: AppDispatch) => {
    dispatch({ type: SET_PREFERENCE_LOADING })
    return setPreferenceCall(name, value, establishmentUuid)
      .then(() => dispatch(setPreferenceSuccess(name, value)))
      .catch((error: AxiosError) =>
        dispatch(setPreferenceFailure(error.message)),
      )
  }
}
